const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
};

/**
 * prevents accidental window closure
 */
export const preventExit = () => {
  window.addEventListener('beforeunload', handleBeforeUnload);
};

/**
 * disable site leaving warning
 */
export const allowExit = () => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
};

/**
 * disable site leaving warning and allows leaving on network change
 */
export const allowAllExit = () => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
  window.addEventListener(
    'beforeunload',
    function (e) {
      e.stopImmediatePropagation();
    },
    true,
  );
};
